module.exports = __webpack_public_path__ + "img/337.4ec06ba.png";